<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
  >
    <g id="icon_list_file" transform="translate(-625 -544)">
      <path
        id="패스_4050"
        data-name="패스 4050"
        fill-opacity="0"
        d="M0,0H24V24H0Z"
        transform="translate(625 544)"
      />
      <g id="그룹_8645" data-name="그룹 8645">
        <g id="그룹_8644" data-name="그룹 8644" transform="translate(0 -2)">
          <rect
            id="사각형_6068"
            data-name="사각형 6068"
            fill="#ffc304"
            width="20"
            height="15.835"
            rx="2"
            transform="translate(627 551)"
          />
          <rect
            id="사각형_6103"
            data-name="사각형 6103"
            fill="#ffc304"
            width="10"
            height="6"
            rx="2"
            transform="translate(627 549)"
          />
          <g
            id="그룹_8643"
            data-name="그룹 8643"
            transform="translate(5.657 -26.172)"
          >
            <rect
              id="사각형_6104"
              data-name="사각형 6104"
              fill="#087ef7"
              width="2"
              height="6"
              transform="translate(625.343 585.929) rotate(-45)"
            />
            <path
              id="패스_4065"
              data-name="패스 4065"
              fill="#087ef7"
              d="M0,0,2.142-.02l-.1,10.708-2.142.02Z"
              transform="translate(635.815 581.172) rotate(45)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
  },
};
</script>
